import { booleanAttribute, ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { RouterLink } from '@angular/router'
import { map } from 'rxjs'

import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'

import { ResponsiveUi } from '../responsive-ui'
import { Scroll } from '../scroll'

@Component({
	selector: 'app-page-header-bar',
	imports: [MatButtonModule, MatIconModule, RouterLink],
	templateUrl: './page-header-bar.html',
	styleUrl: './page-header-bar.scss',
	host: {
		'[class.hidden]': 'hideHeaderBar() && !isDialog()',
		'[class.dialog]': 'isDialog()',
		'[class.single-row]': 'singleRow()',
		'[attr.role]': 'isDialog() ? null : "banner"',
		'[aria-label]': 'isDialog() ? null : "Page title, navigation, and actions"',
	},
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderBar {
	protected readonly responsiveUi = inject(ResponsiveUi)
	private readonly scroll = inject(Scroll)

	readonly title = input('', { alias: 'page-title' })
	readonly isDialog = input(false, { alias: 'dialog', transform: booleanAttribute })
	readonly singleRow = input(false, { alias: 'single-row', transform: booleanAttribute })
	readonly justifyContent = input('normal', { alias: 'justify-content' })
	readonly loading = input(false, { transform: booleanAttribute })
	readonly alwaysShowHeaderBar = input(false, { alias: 'always-show-header-bar', transform: booleanAttribute })

	readonly hideHeaderBar = computed(() => !this.alwaysShowHeaderBar() && this.responsiveUi.isSmallViewport() && this.scrollingDown())
	readonly scrollingDown = toSignal(this.scroll.scrollDirection$.pipe(map(scrollDir => scrollDir === 'down')))
}
